import React from "react";
import { FiShield, FiClock, FiCheckCircle, FiHeadphones, FiPenTool } from "react-icons/fi";

const badges = [
  {
    icon: <FiShield />,
    title: "Secure & Private",
    desc: "Your files are 100% safe with us.",
  },
  {
    icon: <FiClock />,
    title: "24-48 Hours Delivery",
    desc: "We deliver your edited gallery within 24-48 hours.",
  },
  {
    icon: <FiCheckCircle />,
    title: "Free Revision until You're Happy",
    desc: "We work until you're 100% satisfied.",
  },
  {
    icon: <FiHeadphones />,
    title: "24/7 Support",
    desc: "We are always here to help you.",
  },
  {
    icon: <FiPenTool />,
    title: "100% Human Quality Control",
    desc: "Reviewed and approved by a real person - no AI shortcuts.",
  },
];

const TrustBadgesBar = () => {
  return (
    <div className="trust-badges-bar">
      {badges.map((badge) => (
        <div className="trust-badge" key={badge.title}>
          <span className="trust-badge-icon">{badge.icon}</span>
          <div>
            <div className="trust-badge-title">{badge.title}</div>
            <div className="trust-badge-desc">{badge.desc}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrustBadgesBar;
